module.exports = __webpack_public_path__ + "media/images/gobble_july4th/bg-lg-469f6866494c5cf36a40c890e43b7a90.jpg";